module.exports = "/images/white-arrow-up.7f57bf9ef524f8bf8d104e06fcd2fb3c.svg";